import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const approvalStatusApi = tokenSlice.injectEndpoints({
    reducerPath: 'approvalStatus',
    baseQuery: createBaseQuery(),
    endpoints(builder) {
        return {
            getAprovalStatus: builder.query({
                query: () => {
                    return {
                        url: 'Approval/ApprovalStatus',
                        method: 'GET'
                    }
                }
            })
        }
    }
})

export const { useGetAprovalStatusQuery } = approvalStatusApi;
export { approvalStatusApi };